import React, { Component } from "react";
import PropTypes from "prop-types";
import "./LeftMenu.css"

class MenuItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
    };
  }

  componentDidMount() {}

  toggleCollapse = () => {
    this.setState((prevState) => {
      return {
        collapsed: !prevState.collapsed,
      };
    });
  };

  onClick = (e) => {
    if (Array.isArray(this.props.item.items)) {
      this.toggleCollapse();
    } else {
      window.location = this.props.item.path;
    }

  };

  render() {
    return (
      <div
        style={{
          paddingLeft: `8px`,
          textDecoration: 'none !important',
        }}
        className='leftMenu-item-content'
      >
        {this.props.item.icon && (
            <div  className='leftMenu-item-icon'>
          <this.props.item.icon
            fontSize='large'
          />
            </div>
        )}
        <div className='leftMenu-item-text'>{this.props.item.label}</div>
      </div>
    );
  }
}

MenuItem.propTypes = {
  depthStep: PropTypes.number,
  depth: PropTypes.number,
  expanded: PropTypes.bool,
  item: PropTypes.object,
  Icon: PropTypes.element,
};

MenuItem.defaultProps = {
  depthStep: 20,
  depth: 0,
  expanded: false,
};

export default MenuItem;
